<template>
  <div class="confirm-body">
    <div class="confirm-wrp" :style="{width: width}">
      <bcc-icon type="ic_delete_" class="close-icon" @click="$emit('close')"></bcc-icon>
      <p class="main-text">{{mainText}}</p>
      <p class="sub-text">{{subText}}</p>
      <div class="btn-group">
        <div class="confirm" @click="$emit('ok')">{{confirmBtnText}}</div>
        <div class="cancel" @click="$emit('close')">{{cancelBtnText}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "instance.vue",
  props: {
    mainText: String,
    subText: String,
    width: String,
    showCancel: {
      type: Boolean,
      default: true
    },
    confirmBtnText: {
      type: String,
      default: '确认'
    },
    cancelBtnText: {
      type: String,
      default: '取消'
    }
  }
}
</script>

<style scoped lang="scss">
.confirm-body {
  position: fixed;
  z-index: 10000;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
}

.confirm-wrp {
  box-sizing: border-box;
  width: 600px;
  padding: 26px 32px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  background-color: #ffffff;

  .close-icon {
    font-size: 14px;
    position: absolute;
    right: 28px;
    top: 28px;
    cursor: pointer;
    color: #999999;
  }

  .main-text {
    width: 90%;
    font-size: 16px;
    color: #505050;
  }

  .sub-text {
    font-size: 14px;
    color: #212121;
    margin-top: 18px;
  }

  .btn-group {
    margin-top: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    > div {
      width: 104px;
      height: 38px;
      box-sizing: border-box;
      border-radius: 4px;
      font-size: 14px;
      text-align: center;
      cursor: pointer;
    }

    .confirm {
      background: #00A1D6;
      line-height: 38px;
      color: #ffffff;
    }

    .cancel {
      margin-left: 16px;
      border: 1px solid #E7E7E7;
      line-height: 36px;
    }
  }
}
</style>
